<h4 class="card-title" data-automation="subscriptions_title">
    {{ 'user.subscriptions' | translate }}
</h4>
<h6 class="card-subtitle" data-automation="subscriptions_subtitle">
    {{ 'user.subscriptions.subtitle' | translate }}
</h6>
<p *ngIf="shouldShowNaConsentMessage" class="card-subtitle" data-automation="subscriptions_consent_message">
    {{ 'user.subscriptions.na_consent_message' | translate }}
</p>
<mat-toolbar
    *ngIf="isEditMode && (!hasAnyMobilePhoneField || (!hasAnyMobilePhoneField && !hasAnyPhoneField))"
    color="warn"
    class="warning-bar"
>
    <mat-icon>warning</mat-icon>
    <span *ngIf="!hasAnyMobilePhoneField && !hasAnyPhoneField; else text_only" class="warning-text">
        {{ 'user.subscriptions.warning' | translate }}
    </span>
    <ng-template #text_only class="warning-text">
        {{ 'user.subscriptions.text_warning' | translate }}
    </ng-template>
</mat-toolbar>
<mat-toolbar *ngIf="shouldShowNoPushContactMethodBanner" color="warn" class="warning-bar">
    <mat-icon>info</mat-icon>
    <span class="warning-text" data-automation="noPushContactMethodMessage">{{
        'user.table.no_push_contact_method' | translate
    }}</span>
</mat-toolbar>
<div class="sub-separator"></div>
<div class="subscriptions-main-container">
    <div class="table-wrapper">
        <table
            mat-table
            [dataSource]="loading ? [] : dataSource"
            class="mat-elevation-z8 sub-table"
            data-automation="subscriptions-table"
        >
            <!-- Site Search Column -->
            <ng-container matColumnDef="site">
                <th mat-header-cell class="search-th" *matHeaderCellDef>
                    <mat-checkbox
                        class="select-all"
                        [disabled]="!isEditMode"
                        [checked]="allComplete"
                        [color]="'primary'"
                        [indeterminate]="someComplete()"
                        (change)="setAll($event.checked)"
                    >
                        <span *ngIf="allComplete">{{ 'user.table.all_sites' | translate }}</span>
                        <span *ngIf="someComplete()">{{ 'user.table.some_sites' | translate }}</span>
                        <span *ngIf="!allComplete && !someComplete()">{{ 'user.table.no_sites' | translate }}</span>
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'site-name-cb'"
                        [(ngModel)]="subscription.completed"
                        [disabled]="!isEditMode"
                        [color]="subscription.color"
                        (ngModelChange)="updateAllComplete()"
                        (change)="toggleSiteCompleted(subscription)"
                    >
                        {{ subscription.name }}
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Text Column -->
            <ng-container matColumnDef="text">
                <th mat-header-cell class="title centered" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.sms' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefText.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefText
                            (selectionChange)="changeBulkSubAction('sms', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsText" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'text-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.sms"
                        [disabled]="!isEditMode || !hasAnyMobilePhoneField"
                        (change)="
                            handleSubscriptionCheckboxChange('sms', $event);
                            subscription.coachingSms = subscription.sms ? true : subscription.coachingSms
                        "
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Voice Column -->
            <ng-container matColumnDef="voice">
                <th mat-header-cell class="title centered" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.voice' | translate }}
                        <mat-icon class="selector-icon" (click)="matRefVoice.open()">arrow_drop_down</mat-icon>
                    </mat-label>
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefVoice
                            (selectionChange)="changeBulkSubAction('voice', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsVoice" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'voice-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.voice"
                        [disabled]="!isEditMode || !(hasAnyMobilePhoneField || hasAnyPhoneField)"
                        (change)="
                            handleSubscriptionCheckboxChange('voice', $event);
                            subscription.coachingVoice = subscription.voice ? true : subscription.coachingVoice
                        "
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell class="title centered" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.email' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefEmail.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            matInput
                            #matRefEmail
                            (selectionChange)="changeBulkSubAction('email', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsEmail" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'email-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.email"
                        [disabled]="!isEditMode || !hasEmailField"
                        (change)="
                            handleSubscriptionCheckboxChange('email', $event);
                            subscription.coachingEmail = subscription.email ? true : subscription.coachingEmail
                        "
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Push Column -->
            <ng-container matColumnDef="push">
                <th mat-header-cell class="title centered right-border" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.push' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefPush.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            matInput
                            #matRefPush
                            (selectionChange)="changeBulkSubAction('push', $event)"
                            [disabled]="!isSelectEnabled() || !hasContactMethodPush || !hasOnboardingRole"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsPush" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <span [matTooltip]="isEditMode && !hasContactMethodPush ? tooltips.push : ''">
                        <mat-checkbox
                            [attr.data-automation]="'push-cb-' + subscription.tag"
                            class="checkbox"
                            [(ngModel)]="subscription.push"
                            [disabled]="!isEditMode || !hasContactMethodPush"
                            (change)="handleSubscriptionCheckboxChange('push', $event)"
                        >
                        </mat-checkbox>
                    </span>
                </td>
            </ng-container>

            <!-- Coaching Text Column -->
            <ng-container matColumnDef="coachingText">
                <th mat-header-cell class="title centered" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.sms' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefCoachingText.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefCoachingText
                            (selectionChange)="changeBulkSubAction('coachingSms', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsCoachingText" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'coaching-text-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.coachingSms"
                        [disabled]="!isEditMode || !hasAnyMobilePhoneField"
                        (change)="handleSubscriptionCheckboxChange('coachingSms', $event)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Coaching Email column -->
            <ng-container matColumnDef="coachingEmail">
                <th mat-header-cell class="title centered" *matHeaderCellDef data-automation="coachingBlockEmail">
                    <mat-label
                        >{{ 'user.table.email' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefCoaching.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefCoaching
                            (selectionChange)="changeBulkSubAction('coachingEmail', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsCoachingEmail" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'coaching-email-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.coachingEmail"
                        [disabled]="!isEditMode || !hasEmailField"
                        (change)="handleSubscriptionCheckboxChange('coachingEmail', $event)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Coaching Voice Column -->
            <ng-container matColumnDef="coachingVoice">
                <th mat-header-cell class="title centered" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.voice' | translate }}
                        <mat-icon class="selector-icon" (click)="matRefCoachVoice.open()">arrow_drop_down</mat-icon>
                    </mat-label>
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefCoachVoice
                            (selectionChange)="changeBulkSubAction('coachingVoice', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsCoachingVoice" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'coaching-voice-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.coachingVoice"
                        [disabled]="!isEditMode || !(hasAnyMobilePhoneField || hasAnyPhoneField)"
                        (change)="handleSubscriptionCheckboxChange('coachingVoice', $event)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Coaching Push Column -->
            <ng-container matColumnDef="coachingPush">
                <th mat-header-cell class="title centered right-border" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.push' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefCoachingPush.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            matInput
                            #matRefCoachingPush
                            (selectionChange)="changeBulkSubAction('coachingPush', $event)"
                            [disabled]="!isSelectEnabled() || !hasContactMethodPush || !hasOnboardingRole"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsCoachingPush" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <span [matTooltip]="isEditMode && !hasContactMethodPush ? tooltips.push : ''">
                        <mat-checkbox
                            [attr.data-automation]="'coaching-push-cb-' + subscription.tag"
                            class="checkbox"
                            [(ngModel)]="subscription.coachingPush"
                            [disabled]="!isEditMode || !hasContactMethodPush"
                            (change)="handleSubscriptionCheckboxChange('coachingPush', $event)"
                            [matTooltip]="isEditMode && !hasContactMethodPush ? tooltips.push : ''"
                        >
                        </mat-checkbox>
                    </span>
                </td>
            </ng-container>

            <!-- Offer column -->
            <ng-container matColumnDef="offer">
                <th
                    mat-header-cell
                    class="title centered mat-column-offer right-border"
                    *matHeaderCellDef
                    data-automation="offerBlockEmail"
                >
                    <mat-label
                        >{{ 'user.table.email' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefOffer.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefOffer
                            (selectionChange)="changeBulkSubAction('offer', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsOffer" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered mat-column-offer right-border" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'offer-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.offer"
                        [disabled]="!isEditMode || !hasEmailField"
                        (change)="handleSubscriptionCheckboxChange('offer', $event)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Performance column -->
            <ng-container matColumnDef="performance">
                <th mat-header-cell class="title centered" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.email' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefPerformance.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefPerformance
                            (selectionChange)="changeBulkSubAction('performance', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsPerformance" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'performance-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.performance"
                        [disabled]="!isEditMode || !hasEmailField"
                        (change)="handleSubscriptionCheckboxChange('performance', $event)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Payments Email column -->
            <ng-container matColumnDef="paymentEmail">
                <th mat-header-cell class="title centered" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.email' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefPaymentEmail.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefPaymentEmail
                            (selectionChange)="changeBulkSubAction('paymentEmail', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsPaymentEmail" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'payment-email-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.paymentEmail"
                        [disabled]="!isEditMode || !hasEmailField"
                        (change)="handleSubscriptionCheckboxChange('paymentEmail', $event)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Payments Push Column -->
            <ng-container matColumnDef="paymentPush">
                <th mat-header-cell class="title centered right-border" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.push' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefPaymentPush.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            matInput
                            #matRefPaymentPush
                            (selectionChange)="changeBulkSubAction('paymentPush', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsPaymentPush" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'payment-push-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.paymentPush"
                        [disabled]="true"
                        (change)="handleSubscriptionCheckboxChange('paymentPush', $event)"
                        [matTooltip]="isEditMode && !hasContactMethodPush ? tooltips.push : ''"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Reminders Email column -->
            <ng-container matColumnDef="reminderEmail">
                <th mat-header-cell class="title centered" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.email' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefReminderEmail.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefReminderEmail
                            (selectionChange)="changeBulkSubAction('remindersEmail', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsReminderEmail" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered" *matCellDef="let subscription">
                    <span [matTooltip]="isEditMode && !hasOnboardingRole ? tooltips.missing_onboarding_role : ''">
                        <mat-checkbox
                            [attr.data-automation]="'reminders-email-cb-' + subscription.tag"
                            class="checkbox"
                            [(ngModel)]="subscription.remindersEmail"
                            [disabled]="!isEditMode || !hasEmailField || !hasOnboardingRole"
                            (change)="handleSubscriptionCheckboxChange('remindersEmail', $event)"
                        >
                        </mat-checkbox>
                    </span>
                </td>
            </ng-container>

            <!-- Reminders Push Column -->
            <ng-container matColumnDef="reminderPush">
                <th mat-header-cell class="title centered right-border" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.push' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefReminderPush.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            matInput
                            #matRefReminderPush
                            (selectionChange)="changeBulkSubAction('remindersPush', $event)"
                            [disabled]="!isSelectEnabled() || !hasContactMethodPush || !hasOnboardingRole"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsReminderPush" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered right-border" *matCellDef="let subscription">
                    <span [matTooltip]="isEditMode && !hasOnboardingRole ? tooltips.missing_onboarding_role : ''">
                        <span
                            [matTooltip]="isEditMode && !hasContactMethodPush && hasOnboardingRole ? tooltips.push : ''"
                        >
                            <mat-checkbox
                                [attr.data-automation]="'reminder-push-cb-' + subscription.tag"
                                class="checkbox"
                                [(ngModel)]="subscription.remindersPush"
                                [disabled]="!isEditMode || !hasContactMethodPush || !hasOnboardingRole"
                                (change)="handleSubscriptionCheckboxChange('remindersPush', $event)"
                                [matTooltip]="isEditMode && !hasContactMethodPush ? tooltips.push : ''"
                            >
                            </mat-checkbox>
                        </span>
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="alertRuleEmail">
                <th mat-header-cell class="title centered right-border" *matHeaderCellDef>
                    <mat-label
                        >{{ 'user.table.email' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefAlertRuleEmail.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefAlertRuleEmail
                            (selectionChange)="changeBulkSubAction('alertRuleEmail', $event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActionsAlertRuleEmail" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
                <td mat-cell class="centered right-border" *matCellDef="let subscription">
                    <mat-checkbox
                        [attr.data-automation]="'alert-rule-email-cb-' + subscription.tag"
                        class="checkbox"
                        [(ngModel)]="subscription.alertRuleEmail"
                        [disabled]="!isEditMode || !hasEmailField"
                        (change)="handleSubscriptionCheckboxChange('alertRuleEmail', $event)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="header-row-first-group">
                <th mat-header-cell *matHeaderCellDef class="title centered th-site search-column" [attr.colspan]="1">
                    <div [ngClass]="isFocused ? 'search-enabled dr-search' : 'search-disabled dr-search'">
                        <mat-icon class="search-icon">search</mat-icon>
                        <input
                            matInput
                            type="text"
                            class="context-search-input"
                            data-automation="searchSites"
                            (input)="filterSubscriptionTable($event.target.value)"
                            (focus)="onSearchInputFocus()"
                            (blur)="onSearchInputBlur()"
                            placeholder="{{ 'user.table.search_site' | translate }}"
                        />
                    </div>
                </th>
            </ng-container>

            <ng-container matColumnDef="header-row-second-group">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="title centered dispatch main-sections right-border"
                    [attr.colspan]="4"
                >
                    <mat-label
                        >{{ 'user.table.dispatch' | translate
                        }}<mat-icon class="selector-icon" (click)="matRefDispatch.open()"
                            >arrow_drop_down</mat-icon
                        ></mat-label
                    >
                    <mat-form-field class="hidden" style="height: 0.5em" floatLabel="always">
                        <mat-select
                            panelClass="custom-select-panel"
                            #matRefDispatch
                            (selectionChange)="changeBulkSubActions($event)"
                            [disabled]="!isSelectEnabled()"
                        >
                            <mat-option *ngFor="let action of bulkSubActions" [value]="action.value">
                                {{ action.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </th>
            </ng-container>

            <ng-container matColumnDef="header-row-third-group">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="title centered label-info main-sections icon-column mat-column-coaching right-border"
                    data-automation="coachingBlock"
                    [attr.colspan]="4"
                >
                    <mat-label class="align-labels">{{ 'user.table.coaching' | translate }}</mat-label>
                    <mat-icon
                        *ngIf="!isViewMode"
                        data-automation="coachingTooltip"
                        class="tooltip-icon"
                        matTooltip="{{ 'user.tooltip.table.coaching' | translate }}"
                        >info_outline</mat-icon
                    >
                </th>
            </ng-container>

            <ng-container matColumnDef="header-row-fourth-group">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="title centered border-offer label-info main-sections icon-column right-border"
                    data-automation="offerBlock"
                    [attr.colspan]="1"
                >
                    <mat-label class="align-labels">{{ 'user.table.offer' | translate }}</mat-label>
                    <mat-icon
                        *ngIf="!isViewMode"
                        data-automation="offerTooltip"
                        class="tooltip-icon"
                        matTooltip="{{ 'user.tooltip.table.offer' | translate }}"
                        >info_outline</mat-icon
                    >
                </th>
            </ng-container>

            <ng-container matColumnDef="header-row-fifth-group">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="title centered label-info main-sections icon-column mat-column-performance right-border"
                    data-automation="performanceBlock"
                    [attr.colspan]="1"
                >
                    <mat-label class="align-labels">{{ 'user.table.performance' | translate }} </mat-label>
                    <mat-icon
                        *ngIf="!isViewMode"
                        data-automation="performanceTooltip"
                        class="tooltip-icon"
                        matTooltip="{{ 'user.tooltip.table.performance' | translate }}"
                        >info_outline</mat-icon
                    >
                </th>
            </ng-container>

            <ng-container matColumnDef="header-row-sixth-group">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="title centered label-info main-sections icon-column mat-column-payments right-border"
                    data-automation="paymentsBlock"
                    [attr.colspan]="2"
                >
                    <mat-label class="align-labels">{{ 'user.table.payments' | translate }}</mat-label>
                    <mat-icon
                        *ngIf="!isViewMode"
                        data-automation="paymentsTooltip"
                        class="tooltip-icon"
                        matTooltip="{{ 'user.tooltip.table.payments' | translate }}"
                        >info_outline</mat-icon
                    >
                </th>
            </ng-container>

            <ng-container matColumnDef="header-row-seventh-group">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="title centered label-info main-sections icon-column mat-column-reminders right-border"
                    data-automation="remindersBlock"
                    [attr.colspan]="2"
                >
                    <mat-label class="align-labels">{{ 'user.table.reminders' | translate }}</mat-label>
                    <mat-icon
                        *ngIf="!isViewMode"
                        data-automation="remindersTooltip"
                        class="tooltip-icon"
                        matTooltip="{{ 'user.tooltip.table.reminders' | translate }}"
                        >info_outline</mat-icon
                    >
                </th>
            </ng-container>

            <ng-container matColumnDef="header-row-eighth-group">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="title centered label-info main-sections icon-column right-border"
                    data-automation="alertsBlock"
                    [attr.colspan]="1"
                >
                    <mat-label class="align-labels">{{ 'user.table.alerts' | translate }}</mat-label>
                    <mat-icon
                        *ngIf="!isViewMode"
                        data-automation="alertsTooltip"
                        class="tooltip-icon"
                        matTooltip="{{ 'user.tooltip.table.alerts' | translate }}"
                        >info_outline</mat-icon
                    >
                </th>
            </ng-container>

            <ng-container *ngIf="hasOnlyDRFinancialRole; else drSubscriptionGroups">
                <tr
                    mat-header-row
                    *matHeaderRowDef="['header-row-first-group', 'header-row-sixth-group']; sticky: true"
                ></tr>
            </ng-container>
            <ng-template #drSubscriptionGroups>
                <ng-container *ngIf="hasDRFinancialRole; else noDRFinancialRole">
                    <tr
                        mat-header-row
                        *matHeaderRowDef="
                            [
                                'header-row-first-group',
                                'header-row-second-group',
                                'header-row-third-group',
                                'header-row-fourth-group',
                                'header-row-fifth-group',
                                'header-row-sixth-group',
                                'header-row-seventh-group',
                                'header-row-eighth-group'
                            ];
                            sticky: true
                        "
                    ></tr>
                </ng-container>
                <ng-template #noDRFinancialRole>
                    <tr
                        mat-header-row
                        *matHeaderRowDef="
                            [
                                'header-row-first-group',
                                'header-row-second-group',
                                'header-row-third-group',
                                'header-row-fourth-group',
                                'header-row-fifth-group',
                                'header-row-seventh-group',
                                'header-row-eighth-group'
                            ];
                            sticky: true
                        "
                    ></tr>
                </ng-template>
            </ng-template>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <td *ngIf="loading" colspan="displayedColumns.length">
            <div class="spinner-container">
                <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
            </div>
        </td>

        <div *ngIf="!dataSource?.data.length && !loading" class="no-results centered" data-automation="no-results">
            {{ 'user.subscriptions.no_results' | translate }}
        </div>
    </div>
</div>
<mat-paginator
    *ngIf="totalRecords > 4"
    [pageSizeOptions]="[10]"
    [length]="totalRecords"
    (page)="pageEvent = $event; onPaginateChange($event)"
    [pageSize]="pageSize"
    showFirstLastButtons
></mat-paginator>
